exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar_block[data-v-68924714]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68924714","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/CalendarBlock.vue
// module id = d7b58a9d289b203d9b19
// module chunks = 6